<template>
	<div class="container">
        <Navigation-bar title="支付确认"></Navigation-bar>
		<div class="container_content">
			<div id="enrollCashier">
                <Title subtitle="选择支付方式">
                    <template slot="spreadhead">
                        <div class="money">¥<span>{{money}}</span></div>
                    </template>
                </Title>
				<div class="enrollCashier_content">
					<div class="hint">
						<div class="hint_title">*对公转账说明</div>
						<div class="row">1.选择对公转账方式，直接点击确认付款即可，确认后会提示收款账户信息。</div>
						<div class="row">2.因报名名额有限，为了不影响您的报名的有效性，请尽快完成对公转账操作。</div>
						<div class="row">3.转账后，请您及时与客服人员确认转账信息，系统将会在第一时间更改您的报名状态为“已报名”。</div>
					</div>
					<div class="payment">
						<div class="item" :class="{'active': payment == 1}">
							<div class="item_title" @click="payment = 1">
								<YD-image src="icon/icon_WeChatPay"></YD-image>
								<span>微信支付</span>
							</div>
						</div>
						<div class="item" :class="{'active': payment == 2}">
							<div class="item_title" @click="payment = 2">
								<YD-image src="icon/icon_publicTransfer"></YD-image>
								<span>对公账户</span>
							</div>
							<div class="item_content">
								<div class="info">
									<ul>
										<li>
											<span>账户名称</span>
											<span>中国企业体育协会</span>
										</li>
										<li>
											<span>开户银行</span>
											<span>中国建设银行北京静安庄支行</span>
										</li>
										<li>
											<span>账号</span>
											<span>11050166540000000144</span>
										</li>
									</ul>
								</div>
								<div class="operation">
									<span>付款账户信息</span>
									<button class="copy" @click="copy()">复制</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<button class="confirm" @click="confirm()">{{buttonText}}</button>
		</div>
	</div>
</template>

<script>
import operate from '@/common/operate.js';
import communicate from '@/common/communicate.js';
import appInteraction from '@/common/appInteraction.js';
import {
	UserLeagueEnrollGotoPay
} from '@/api';

export default {
    name: "EnrollCashier",
    data(){
        let type = +this.$route.query.type,
            money = +this.$route.query.money,
            orderId = +this.$route.query.id;
        return{
            /**
             * 1: 代表队支付
             * 2：个人支付
             * */
            type,
            money,
            orderId,
            payment: 1,
            isPayEvent: true
        }
    },
    computed:{
        buttonText(){
            return this.payment == 1 ? '确认付款' : '确认提交';
        }
    },
    methods:{
        confirm(){
            if(!this.isPayEvent)return;
            this.isPayEvent = false;
            if(this.payment == 1){
                UserLeagueEnrollGotoPay({
                    LeagueEnrollOrderId: this.orderId,
                    PaymentMode: 1,
                    TradeType: "APP",
                    FeeTotal: this.money,
					PayerId: ""
                }).then(data => {
                    this.isPayEvent = true;
                    if(data.Code === 0){
                        this.openWxPay(data.AppPayParms);
                    }
                }).catch(()=>{
                    this.isPayEvent = true;
                })
            }else{
                UserLeagueEnrollGotoPay({
                    LeagueEnrollOrderId: this.orderId,
                    PaymentMode: 0,
                    TradeType: "",
                    FeeTotal: this.money,
                    PayerId: null
                }).then(data => {
                    this.isPayEvent = true;
                    if(data.Code === 0){
                        this.$Prompt({
                            title: "提交成功",
                            message: "请尽快完成转账操作",
                    		confirmText: "知道了"
                        }).then(()=>{
							this.$navigation.back();
						})
                    }
                }).catch(()=>{
                    this.isPayEvent = true;
                })
            }
        },
        openWxPay(PayParams){
            appInteraction.requestPayment({
                Provider: "wxpay",
				PayParams: PayParams
            }).then(data=>{
				if(data.Status == 0){
                    communicate.paySuccess.$emit();
                    this.$Prompt({
                        title: "支付成功",
                        message: "如需发票可在比赛现场或者联系客服开具",
						confirmText: "知道了"
					}).then(()=>{
						this.$navigation.back();
					})
				}else{
                    this.$navigation.back();
				}
			})
        },
        copy(){
            operate.copy(`账户名称：中国企业体育协会\n开户银行：中国建设银行北京静安庄支行\n账号：11050166540000000144`).then(()=>{
                this.$Toast('复制成功');
            });
        }
    }
}
</script>

<style lang="scss">
	.enrollCashier{
		padding: 0 40px;
		box-sizing: border-box;
	}
	.money{
		font-family: PingFangSC-Medium;
		font-size: 36px;
		color: #F34911;
		line-height: 84px;
		font-weight: 500;
		span{
			font-size: 60px;
			margin-left: 15px;
		}
	}
	.enrollCashier_content{
		padding: 0 40px;
	}
	.hint{
		margin-top: 40px;
		margin-bottom: 120px;
		.hint_title{
			font-family: PingFangSC-Medium;
			font-size: 28px;
			color: #1B1C1E;
			font-weight: 500;
			margin-bottom: 24px;
		}
		.row{
			font-family: PingFangSC-Regular;
			font-size: 24px;
			color: #585D65;
			line-height: 38px;
			font-weight: 400;
		}
	}
	.payment{
		padding-bottom: calc(148px + var(--safe-area-inset-bottom) + 40px);
		.item{
			width: 100%;
			height: auto;
			border-radius: 20px;
			margin-bottom: 16px;
			&.active{
				background: #FAFBFA;
				.item_title::after{
					background: #7AD21A;
					border: 2px solid rgba(255,255,255,1);
				}
				.item_content{
					display: block;
				}
			}
			.item_title{
				width: 100%;
				height: 104px;
				display: flex;
				align-items: center;
				padding-left: 36px;
				box-sizing: border-box;
				position: relative;
				&::after{
					content: '';
					width: 24px;
					height: 24px;
					border-radius: 50%;
					background: #E9E9E9;
					position: absolute;
					top: 40px;
					right: 40px;
				}
				img{
					width: 56px;
					height: 56px;
					margin-right: 16px;
				}
				span{
					font-family: PingFangSC-Medium;
					font-size: 28px;
					color: #1B1C1E;
					font-weight: 500;
				}
			}
			.item_content{
				display: none;
				padding: 8px 40px 32px 108px;
				.info{
					li{
						height: 40px;
						width: 100%;
						display: flex;
						justify-content: space-between;
						margin-bottom: 24px;
						font-family: PingFangSC-Regular;
						font-size: 28px;
						font-weight: 400;
						line-height: 40px;
						span:nth-of-type(1){
							color: #999999;
						}
						span:nth-of-type(2){
							color: #666666;
						}
					}
				}
				.operation{
					width: 100%;
					height: 56px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-top: 40px;
					span{
						font-family: PingFangSC-Medium;
						font-size: 28px;
						color: #1B1C1E;
						font-weight: 500;
					}
					.copy{
						width: 104px;
						height: 56px;
						background: #1B1C1E;
						box-shadow: 0px 6px 10px 0px rgba(27,28,30,0.25);
						border-radius: 28px;
						font-family: PingFangSC-Medium;
						font-size: 28px;
						color: #FFFFFF;
						font-weight: 500;
						line-height: 56px;
					}
				}
			}
		}
	}
	.confirm{
		width: 288px;
		height: 108px;
		background: #1B1C1E;
		box-shadow: 0px 10px 20px 0px rgba(27,28,30,0.25);
		border-radius: 54px;
		font-family: PingFangSC-Medium;
		font-size: 32px;
		color: #FFFFFF;
		font-weight: 500;
		line-height: 108px;
		position: fixed;
		bottom: calc(40px + var(--safe-area-inset-bottom));
		left: calc(50% - 144px);
	}
</style>